<script lang="ts" setup>
	import { twMerge } from 'tailwind-merge'
	const { class: c, alt, fallbackImg, effect, height, modifiers = {} } = defineProps<{
		class?: string
		fallbackImg?: string
		alt?: string
		height?: string | number
		loading?: 'lazy' | 'eager',
		effect?: string
		modifiers?: any
	}>()
	if (effect)
		modifiers.effect = effect

	const error = ref(false)
	const emit = defineEmits<{
  		loaded: [event: Event]
	}>()
	const onLoad = (event: Event) => {
		requestAnimationFrame(() => {
    		emit('loaded', event)
 		})
	}
</script>
<template>
	<NuxtImg
		#="{ src, isLoaded, imgAttrs }"
		:height="height"
		:custom="true"
		:modifiers="modifiers"
		@error="error = true"
		@load="onLoad"
	>
		<img v-lazy-load  v-if="error && fallbackImg" :data-src="fallbackImg" :class="c" alt="Fallback-Image" loading="lazy" />
		<slot v-else-if="error && !fallbackImg" name="fallback">
			<div
				class="flex items-center justify-center text-center"
				:class="twMerge('bg-black/20 text-white', c)"
				:style="c && c.indexOf('h-') === -1 && height ? `height: ${height}px` : undefined">
				<span class="p-6">Bild konnte nicht gefunden werden !</span>
			</div>
		</slot>
		<img v-lazy-load  v-else-if="isLoaded" :data-src="src" v-bind="imgAttrs" :class="c" :alt="alt" :loading="loading" />
		<div
			v-else
			class="flex items-center justify-center text-center"
			:class="twMerge('bg-black/50 text-white', c)"
			:style="c && c.indexOf('h-') === -1 && height ? `height: ${height}px` : undefined"
		>
			<GsIcon name="i-mdi-loading" class="mr-3 size-12 text-white animate-spin" />
		</div>
	</NuxtImg>
</template>
